const LOGO_URL = "https://customer-assets.emergentagent.com/job_c3a7541a-5f11-4b28-86fe-c536ebcd97c4/artifacts/9cejcg8w_Solimo%CC%83es%20Card.png";

export default function SolimoesLogo({ className = "h-12 w-auto", alt = "Solimões Card" }) {
  return <img src={LOGO_URL} alt={alt} className={className} data-testid="solimoes-logo" />;
}
